import { ISelectOption } from '@/types/ui';

export const teachersLimit = 10;
export const requiredMessage = 'Обязательное поле';

export const laguageOptions: ISelectOption[] = [
  { label: 'Русский', value: 'ru' },
  { label: 'Английский', value: 'en' },
];
